import { formatINR } from "../../../lib/loanMath";

function Line({ k, v, color }) {
  return (
    <div className="flex justify-between gap-4">
      <span className="inline-flex items-center gap-1">
        {color && <span className="inline-block w-2 h-2 rounded-sm" style={{ background: color }} />}{k}
      </span>
      <b className="tabular-nums">{v}</b>
    </div>
  );
}

export function ChartTooltip({ active, payload, mode, loanNames, events, display, drawn }) {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  const ev = (events || []).filter((e) => e.label === r.label);
  return (
    <div className="card-flat p-2.5 text-[11px] space-y-0.5 shadow-lg min-w-[210px]" data-testid="chart-tooltip">
      <div className="font-semibold mb-1 flex justify-between gap-2">
        <span>{r.label}</span>
        <span className="text-[9px] text-muted-foreground uppercase">{r.status}</span>
      </div>
      <Line k="Principal" v={formatINR(r.principal)} color="#2B7BB9" />
      <Line k="Interest" v={formatINR(r.interest)} color="#D9622B" />
      {display === "pct" && <Line k="Share of EMI" v={`${r.pct_principal}% / ${r.pct_interest}%`} />}
      <Line k="Outstanding" v={formatINR(r.balance)} color="#8E5BA8" />
      {r.prepayment > 0 && <Line k="Prepayment" v={formatINR(r.prepayment)} color="#2E9E6B" />}
      <div className="border-t hairline my-1" />
      <Line k="Running principal" v={formatINR(r.cum_principal)} />
      <Line k="Running interest" v={formatINR(r.cum_interest)} />
      {mode === "split" && (
        <>
          <div className="border-t hairline my-1" />
          {loanNames.map((n, j) => (
            <Line key={n} k={n} color={drawn[j]?.color}
                  v={`${formatINR(r[`L${j}_principal`], true)} P · ${formatINR(r[`L${j}_interest`], true)} I`} />
          ))}
        </>
      )}
      {ev.map((e) => (
        <div key={e.text} className="text-[10px] text-[hsl(var(--secondary))] pt-0.5">• {e.text}</div>
      ))}
    </div>
  );
}
